import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/supplierPayment',
    meta: { title: '供应商付款管理' },
    component: Layout,
    redirect: '/supplierPayment/list',
    children: [
      {
        path: 'list',
        meta: { title: '供应商付款管理', activeMenu: '/supplierPayment' },
        component: () => import('@/views/supplierPayment/SupplierPayment.vue')
      },
      {
        path: 'detail',
        meta: { title: '供应商付款详情', activeMenu: '/supplierPayment' },
        component: () => import('@/views/supplierPayment/SupplierPaymentDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增供应商付款', activeMenu: '/supplierPayment' },
        component: () => import('@/views/supplierPayment/SupplierPaymentAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑供应商付款', activeMenu: '/supplierPayment' },
        component: () => import('@/views/supplierPayment/SupplierPaymentAdd.vue')
      }

    ]
  }

]
